import type { QueryClient } from "@tanstack/react-query";
import { createRequireAuthBeforeLoad } from "@my-langguth/auth-ui";
import { whoAmIOptions } from "@/client/@tanstack/react-query.gen";
import { retryFunc } from "@/api/retry";

/** Routes that do not require an authenticated session */
export const SHOP_PUBLIC_ROUTE_IDS = new Set([
  "/login",
  "/request-password-reset",
  "/reset-password",
  "/new-user-setup",
  "/legal/licenses",
]);

export const requireShopAuth = createRequireAuthBeforeLoad({
  loginPath: "/login",
  getSessionQueryOptions: () =>
    ({
      ...whoAmIOptions(),
      retry: retryFunc,
    }) as Parameters<QueryClient["ensureQueryData"]>[0],
});
